import { Spin } from 'antd';
import { HeatmapChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  xData: string[];
  yData: string[];
  data: Array<[number, number, number]>;
}

function HeatmapWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'heatmap', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <HeatmapChart xData={data?.xData ?? []} yData={data?.yData ?? []} data={data?.data ?? []} />;
}

export const heatmapWidgetDef: WidgetDefinition = {
  type: 'heatmap',
  name: 'Heatmap',
  description: 'Matrix intensity visualization',
  icon: 'HeatMapOutlined',
  category: 'chart',
  defaultTitle: 'Heatmap',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: HeatmapWidget,
  settingsSchema: { fields: [] },
};
